import { object, string, number } from "yup";

export const initialValues = {
  amount: 5,
  message: "",
  cardId: null,
};

export const sendTipValidationSchema = object().shape({
  amount: number().required(),
  message: string().optional(),
});

export const selectCardFormValidationSchema = object().shape({
  cardId: number().required("CARD_ID_REQUIRED"),
});
